import {Link} from 'react-router-dom';
import React/*, {useState}*/ from 'react';

import {useracc, postApi} from '../utils/functions';
import {UserContext} from '../utils/usercontext';
import EventEmitter from '../utils/emmiter';
import Genres from './components/genres/genres';
import AudioBox from './components/audio/audiobox';
import moment from 'moment';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import './components/fontawesome/fontawesome';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from "swiper";
import 'swiper/css';

import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';

import './css/index.css';
import './css/header.css';

class Index extends React.Component {
  static contextType = UserContext;
  constructor(props) {
    super(props);
    this.state = {
			status: false,
			clubbers: {},
			radio: {},
			next: {},
			posters: {},
			sets: {},
			event: {},

			IndexSchedule: null,
			affliiate: {},
		};
  };

  async componentDidMount() {
		document.title = "Mix365 Radio - your music station streaming 24/7";
		const value = this.context;
		const getUser = await useracc();
		value.setUser( getUser );
		value.setTheme( '/themes/default-dark.css' );
		EventEmitter.emit('/client', {data: 'no value'});


		let params = new URLSearchParams();
		const x = await postApi('/api/v2/index', params);
		this.setState({clubbers: x.data.Clubbers, radio: x.data.Radio, next: x.data.Next, posters: x.data.WeeklyDJs, sets: x.data.Sets, status: true, affliiate: x.data.Affiliate});

		const IndexSchedule = EventEmitter.addListener('/index/schedule', async data => {
			this.setState({next: data.Next, live: data.Live});
		}); this.setState({IndexSchedule});


	}

	componentWillUnmount() {
	}


	

	render() {
		//const user = this.context;
		const next = 
      Object.keys(this.state.next).map((e,i) => {
        return (
					<SwiperSlide key={i} className="home-next-swiper-card">
						<Link to={`/${this.state.next[e].channel}`}>
							<div className="" style={{backgroundImage: `url("https://mix365.co.uk${this.state.next[e].avatar}")`,  backgroundRepeat: 'no-repeat', backgroundSize: '100% 200px', borderBottom: '3px solid var(--main-primary-color)'}}>
								<div className="home-next-swiper-content">
									{/*<img src={`https://mix365.co.uk${this.state.next[e].avatar}`} width="200px" height="200px" />*/}
									{/*<div className="home-next-swiper-content-genres">
										<Genres genres={this.state.next[e].genres} limit={2} />
									</div>*/}
									<div className="home-next-swiper-content-dj">
										{this.state.next[e].djtitle?this.state.next[e].djtitle:this.state.next[e].username}<br />
									</div>
									<div className="home-next-swiper-content-time">
										{moment(this.state.next[e].start*1000).format("HH:mm")} - {moment(this.state.next[e].end*1000).format("HH:mm")} - {this.state.next[e].channel}
									</div>

								</div>
							</div>
						</Link>
					</SwiperSlide>
				)
			});
		const posters = 
      Object.keys(this.state.posters).map((e,i) => {
        return (
					<SwiperSlide key={i} className="weeklydjs-card">
						<div className="weeklydjs-avatar">
							<Link to={`/${this.state.posters[e].username.replaceAll(' ','_')}`}><img src={`https://mix365.co.uk/${this.state.posters[e].avatar}`} alt="DJ Profile Avatar" className="weeklydjs-avatar-img" /></Link>
						</div>
						<Row className="home-nl-bottom gx-0">
							{/*<div style={{width: 80}}><img src={`https://mix365.co.uk${this.state.radio.avatar}`} className="home-stream-profile" alt="DJ Profile Avatar" /></div>*/}
							<Col xs={12}>
								{this.state.posters[e].title?this.state.posters[e].title:this.state.posters[e].username}<br />
								
								
							</Col>
							<Col xs={12}>
								{Object.keys(this.state.posters[e].sets).map((f,j) => {
        					return (
										<React.Fragment key={j}>{moment(this.state.posters[e].sets[f]*1000).format("dddd - HH:mm")}<br /></React.Fragment>
									)
								})}
							</Col>
							<Col xs={12}>
								<ul className="weeklydjs-socials">
									{this.state.posters[e].facebook &&
										<li>
											<a href={this.state.posters[e].facebook} title="Facebook" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" />
											</a>
										</li>
									}
									{/*<li>H</li>*/}
									{this.state.posters[e].instagram &&
										<li>
											<a href={this.state.posters[e].instagram} title="Instagram" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" />
											</a>
										</li>
									}
									{this.state.posters[e].mixcloud &&
										<li>
											<a href={this.state.posters[e].mixcloud} title="Mixcloud" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'mixcloud']} className="header-socials" />
											</a>
										</li>
									}
									{this.state.posters[e].soundcloud &&
										<li>
											<a href={this.state.posters[e].soundcloud} title="Soundcloud" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'soundcloud']} className="header-socials" />
											</a>
										</li>
									}
									{this.state.posters[e].twitch &&
										<li>
											<a href={this.state.posters[e].twitch} title="Twitch" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'twitch']} className="header-socials" />
											</a>
										</li>
									}
									{this.state.posters[e].youtube &&
										<li>
											<a href={this.state.posters[e].youtube} title="Youtube" target="_blank" rel="noreferrer">
												<FontAwesomeIcon icon={['fab', 'youtube']} className="header-socials" />
											</a>
										</li>
									}
								</ul>
							</Col>
						</Row>
					</SwiperSlide>
				)
      })
		const previous = 
      Object.keys(this.state.sets).map((e,i) => {
        return (
					<Col md={4} key={i}>
						<AudioBox audio={this.state.sets[e]} />
					</Col>
        )
      })
		return (
			<>
				{this.state.status &&
					<>
						<div className="home-intro">
							<div className="home-intro-background"></div>
							<div className="home-inner"></div>
						</div>
						{/*<div className="website-background"></div>*/}
						<div className="article">
							<div className="home">
								<div className="home-live text-vcenter">
									<div className="text-vertical">
										<div>
											<div className="home-header-white">WELCOME TO</div>
											<div className="home-body">MIX365 RADIO</div>
											{/*<div className="home-footer">FOOTER</div>*/}
										</div>
										{/*<div>
											<div className="home-live-header"><Genres genres={"Techno, House music"} limit={2} marginTop={5} fontSize={'1.25em'} />&nbsp;&nbsp;Now on Air</div>
											{/*<div className="home-live-body">Sunday Trance Sessions</div>*}
											<div className="home-live-body"><Link to={'/clubbers'}>MIX365 Clubbers</Link></div>
											<div className="home-live-footer">PRESENTED BY hamish macbeth</div>
										</div>*/}
									</div>
								</div>
								
									<Row className=" gx-0">
										<Col md={5} className="">
											<div className="home-next home-next-today text-vertical">
												<div className="home-next-bottom">
													<span>Todays</span><br />Radio Shows
												</div>
											</div>
										</Col>
										<Col md={7} className="home-next text-vertical">
											<div className="home-next-swiper">
												<Swiper
													spaceBetween={20}
													navigation={{
														prevEl: '.swiper-prev',
														nextEl: '.swiper-next',
													}}
													breakpoints={{576: {slidesPerView: 1,},768: {slidesPerView: 1,},992: {slidesPerView: 2,},1200: {slidesPerView: 3,},1400: {slidesPerView: 3,}}}
													pagination={{ clickable: true }}
													modules={[Autoplay, Navigation]} autoplay={{delay: 5000,disableOnInteraction: false,}}
												>
													{next}
												</Swiper>
												<div className="swiper-prev"><FontAwesomeIcon icon="circle-left" size="2x" /></div>
    										<div className="swiper-next"><FontAwesomeIcon icon="circle-right" size="2x" /></div>
											</div>
										</Col>
									</Row>
								</div>
						</div>

						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Welcome to MIX365
							</h2>
						</div>

						<div className="home-aboutus">
							
								<Row className="article-entry gx-0 my-5">
									<Col md={6}>
										<img src="/images/home_about.jpg" alt="About Mix365" />
									</Col>
									<Col className="text-vertical ">
										<div className="home-aboutus-text">
											<h1>
												<span>online internet Radio Station</span>
												Welcome to mix365
											</h1>
											<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
											<p>
												Welcome to the home of Mix365. Its the home of two internet radio stations, Mix365 Radio and Mix365 Clubbers.
												We are pleased that you found us. Over on Mix365 Radio we provide the best mix from our live DJs from the 80's through to the current top 40 covering many genres
												and over on Mix365 Clubbers our DJs give you the best in dance, club, house and trance.
											</p>
											
											<Link to='/about'><Button size="sm">Read more</Button></Link>
										</div>
									</Col>
									<Col xs={12}></Col>

									<Col className="text-vertical">
										<div className="home-aboutus-text text-right">
											<h1>
												<span>Schedule</span>
												Mix365 Clubbers
											</h1>
											<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
											<p>Mix365 is your station that comes alive with audio streaming 24/7, LIVE DJ performances and LIVE video streaming to all of the major video on demand platforms. We pride ourselves in everything we do. Take a look around the website.. see what we are all about, see the DJ schedule and find out when your favorite DJ is playing next. We aim to provide you with a great service, this is a place to enjoy yourself.. a place where you can keep coming back time after time..</p>
											<Link to='/clubbers/schedule'><Button size="sm">View Schedule</Button></Link>
										</div>
										
									</Col>

									<Col md={6}>
										<img src={`https://mix365.co.uk/images/live/clubbers-schedule.png?d=${Date.now()}`} alt="About Mix365" />
									</Col>

									<Col md={6}>
										{Object.keys(this.state.clubbers).length > 0 ?
											<img src={`https://mix365.co.uk/images/live/${this.state.clubbers.uid}.png?d=${Date.now()}`} alt="About Mix365" />
										:
											<img src={`https://mix365.co.uk/images/live/61.png?d=${Date.now()}`} alt="About Mix365" />
										}
									</Col>
									<Col className="text-vertical ">
										<div className="home-aboutus-text">
											<h1>
												<span>Interact</span>
												Live Stream
											</h1>
											<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
											<p>
												So why not take a look at our 2 great channels.. see what you think. You are more than welcome to come into the chat rooms and come say hi, to chat you will need to get yourself logged in and then you have free reins to come and support our DJs in every way you can
											</p>
											<Link to='/clubbers'><Button size="sm">Live Stream</Button></Link>
										</div>
									</Col>
								</Row>
							
						</div>
						{Object.keys(this.state.event).length > 0 &&
							<>
								<div className="splitter text-center">
									<div className="splitter-cover"></div>
									<h2 className="splitter-text">
										Event XYZ
									</h2>
								</div>
								<div className="home-aboutus">
									<div className="article">
										<Row className="article-entry">
											<Col>
												<h3>Event XYZ</h3><br />
												Some description of the next upcoming event<br /><br />
												<Link to='/about'><Button size="sm">Read more</Button></Link>
											</Col>
											<Col md={4}>
												<img src="/images/home-bg01.jpg" alt="About Mix365" />
											</Col>
										</Row>
									</div>
								</div>
							</>
						}
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Meet the Mix365 DJ's
							</h2>
						</div>
						<div className="home-aboutus">
							<Row className="article-entry">
								<Col className="text-vertical">
									<div className="home-aboutus-text">
										<h1>
											<span>REGULAR DJ'S</span>
											Meet our Mix365 Weekly DJ's
										</h1>
										<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
										<p>
											Need content
										</p>
										<Link to='/mix365djs'><Button size="sm">View All DJ'a</Button></Link>
									</div>
								</Col>
							</Row>
							<div className="article">
								<Row className="article-entry">
									<Col className="weeklydjs">
										<Swiper
											spaceBetween={50}
											breakpoints={{576: {slidesPerView: 1,},768: {slidesPerView: 2,},992: {slidesPerView: 3,},1200: {slidesPerView: 4,},1400: {slidesPerView: 5,}}}
											navigation={{
												prevEl: '.swiper2-prev',
												nextEl: '.swiper2-next',
											}}
											pagination={{clickable: true}}
											modules={[Autoplay, Navigation]}
											autoplay={{delay: 5000, disableOnInteraction: false,}}
										>
											{posters}
										</Swiper>
										<div className="swiper2-prev"><FontAwesomeIcon icon="circle-left" size="2x" /></div>
    								<div className="swiper2-next"><FontAwesomeIcon icon="circle-right" size="2x" /></div>
									</Col>
								</Row>
							</div>
						</div>
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Replay A Show
							</h2>
						</div>
						<div className="home-aboutus">
							
							<Row className="article-entry">
								<Col className="text-vertical">
									<div className="home-aboutus-text">
										<h1>
											<span>REPLAY SHOW</span>
											PREVIOUS SETS
										</h1>
										<span className="home-aboutus-span">Bringing you more than just great muisc</span><br /><br />
										<p>
											Here at Mix365 we appreciate that life gets in the way sometimes and not everyone has the time to listen to us live, thats why here at Mix365 we try and make life that little bit easier for you all. Did you know that every one of our DJs shows are accessible again for your listening pleasure. Just simply head over to the previous shows page and you can search for your favorite DJ/Show and catch up.
										</p>
										<Link to='/previous-sets'><Button size="sm">Previous Sets</Button></Link>
									</div>
								</Col>
							</Row>
							<div className="article">
								<Row className="article-entry h-100">
									{previous}
								</Row>
							</div>
						</div>
						<div className="splitter text-center">
							<div className="splitter-background"></div>
							<h2 className="splitter-text">
								Follow Us
							</h2>
						</div>
						<div className="home-aboutus">
							<div className="article text-center">
								<ul className="home-followus">
									<li>
										<a href="https://www.facebook.com/groups/mix365" title="Facebook" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'facebook-f']} className="header-socials" /> Facebook
										</a>
									</li>
									<li>
										<a href="https://www.instagram.com/mix365radio/" title="Instagram" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'instagram']} className="header-socials" /> Instagram
										</a>
									</li>
									<li>
										<a href="https://twitter.com/Mix365R" title="Twitter" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'twitter']} className="header-socials" /> Twitter
										</a>
									</li>
									<li>
										<a href="https://discord.gg/DtRYeVPJ5J" title="Discord" target="_blank" rel="noreferrer">
											<FontAwesomeIcon icon={['fab', 'discord']} className="header-socials" /> Discord
										</a>
									</li>
								</ul>
							</div>
						</div>
						{Object.values(this.state.affliiate).length > 0 &&
							<div className="affiliates">
								<div className="text-center">
									<a href={this.state.affliiate.url} alt="affiliates" target="_blank" rel="noreferrer">
										<img src={`https://mix365.co.uk${this.state.affliiate.image}`} />
									</a>
								</div>
							</div>
						}
					</>
				}
			</>
		);
	}
}

export default Index;